import { createSlice } from '@reduxjs/toolkit';

import { selectPlanAndProceed } from '@/store/affiliate/actions/planSelect';

export const STEPS = {
  plans: 'plan',
  auth: 'auth',
  paymentMethods: 'methods',
  cardForm: 'cardForm',
  success: 'success',
  successWithDownload: 'successWithDownload',
  successForAppUser: 'successForAppUser',
  successForExtensionUser: 'successForExtensionUser',
} as const;

type PossibleStep = (typeof STEPS)[keyof typeof STEPS];

export interface StepsState {
  current: PossibleStep;
}
const initialState: StepsState = {
  current: STEPS.plans,
};

export const stepsSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    switchToPaymentMethodsStep: (state) => {
      state.current = STEPS.paymentMethods;
    },
    switchToAuthStep: (state) => {
      state.current = STEPS.auth;
    },
    switchToPlansStep: (state) => {
      state.current = STEPS.plans;
    },
    switchToCardFormStep: (state) => {
      state.current = STEPS.cardForm;
    },
    switchToSuccessStep: (state) => {
      state.current = STEPS.success;
    },
    switchToSuccessStepWithDownload: (state) => {
      state.current = STEPS.successWithDownload;
    },
    switchToSuccessStepForAppUser: (state) => {
      state.current = STEPS.successForAppUser;
    },
    switchToSuccessForExtensionUser: (state) => {
      state.current = STEPS.successForExtensionUser;
    },
  },
  extraReducers(builder) {
    builder.addCase(selectPlanAndProceed.fulfilled, (state, action) => {
      if (action.payload.isProfileLoaded) {
        state.current = STEPS.paymentMethods;
      } else {
        state.current = STEPS.auth;
      }
    });
  },
});

export const {
  switchToPaymentMethodsStep,
  switchToAuthStep,
  switchToPlansStep,
  switchToCardFormStep,
  switchToSuccessStep,
  switchToSuccessStepWithDownload,
  switchToSuccessStepForAppUser,
  switchToSuccessForExtensionUser,
} = stepsSlice.actions;
